/**
 * RunState — persistent data for a single game run.
 *
 * Stored in game.registry so it persists across scene transitions.
 */

import { PlayerCharacter } from "../character/PlayerCharacter";

export interface RunState {
  player: PlayerCharacter;
  deck: string[];
  currentNodeId: string | null;
  mapSeed: number;
  visitedNodes: Set<string>;
  /** Node IDs on high alert (adjacent to a recent battle). */
  alertNodes: Set<string>;
  /** Number of battles won this run. */
  battlesWon: number;
  /** Total shop purchases this run (drives price escalation). */
  shopPurchases: number;
}

export function createRunState(): RunState {
  return {
    player: new PlayerCharacter(10, 0, 1),
    deck: [],
    currentNodeId: null,
    mapSeed: Math.floor(Math.random() * 999999),
    visitedNodes: new Set(),
    alertNodes: new Set(),
    battlesWon: 0,
    shopPurchases: 0,
  };
}
